$(document).ready(function () {
    'use strict';

    $('header').on('click', '.js-toggle-menu', function() {
        $('.js-menu-header').toggleClass('open');
        $('body').toggleClass('menu-open');
    });

});
